var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:file-excel-fill"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3236",
    x: 14,
    y: 14,
    width: 21,
    height: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3333 4.16699L43.75 14.5837V43.767C43.7494 44.3153 43.5312 44.841 43.1433 45.2285C42.7554 45.616 42.2296 45.8337 41.6812 45.8337H8.31875C7.77162 45.8298 7.24795 45.611 6.86087 45.2243C6.47379 44.8376 6.25436 44.3141 6.25 43.767V6.23366C6.25 5.09199 7.17708 4.16699 8.31875 4.16699H33.3333ZM27.5 25.0003L33.3333 16.667H28.3333L25 21.4295L21.6667 16.667H16.6667L22.5 25.0003L16.6667 33.3337H21.6667L25 28.5712L28.3333 33.3337H33.3333L27.5 25.0003Z",
    fill: "#0FA958"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlIcon);
export default __webpack_public_path__ + "static/media/xlIcon.3595051923cb1c37859745548e8445ba.svg";
export { ForwardRef as ReactComponent };